import React from 'react';
import Header from './header/Header';
import About from './about/About';
import Forms from './forms/Forms';
import AreaOfActivity from './activity/AreaOfActivity';
import Notaries from './notaries/Notaries';
import Contact from './contact/Contact';
// import JobDescriptions from './jobDescription/JobDescriptions';

const Main = () => {
  return (
    <>
      <Header />
      <main>
        <About />
        <Forms />
        <AreaOfActivity />
        <Notaries />
        {/*<JobDescriptions />*/}
        <Contact />
      </main>
    </>
  );
};

export default Main;
